import { makeActionCreator } from '../../config/store/utils'
import { getProvidersByBusinessName, getProvidersByDni, getProvidersById } from '../../services/providers'

const SERVICES_DICTIONARY = {
  'business-name': getProvidersByBusinessName,
  dni: getProvidersByDni,
  id: getProvidersById
}

export const GET_SPECIFIC_PROVIDERS = 'GET_SPECIFIC_PROVIDERS'
export const GET_SPECIFIC_PROVIDERS_ERROR = 'GET_SPECIFIC_PROVIDERS_ERROR'
export const GET_SPECIFIC_PROVIDERS_SUCCESS = 'GET_SPECIFIC_PROVIDERS_SUCCESS'
export const onGetSpecificProviders = makeActionCreator(GET_SPECIFIC_PROVIDERS)
export const onGetSpecificProvidersError = makeActionCreator(GET_SPECIFIC_PROVIDERS_ERROR, 'payload')
export const onGetSpecificProvidersSuccess = makeActionCreator(GET_SPECIFIC_PROVIDERS_SUCCESS, 'payload')
export const onGetSpecificProvidersThunk = payload => async dispatch => {
  dispatch(onGetSpecificProviders())

  try {
    const { data } = await SERVICES_DICTIONARY[payload.identifierType]({
      actionType: GET_SPECIFIC_PROVIDERS,
      businessName: payload.businessName,
      dni: payload.dni,
      id: payload.id,
      page: payload.page
    })
    const records = data.payload?.respuesta?.map(item => ({ dni: item.rut, name: item.razonsocial })) || []

    return dispatch(
      onGetSpecificProvidersSuccess({
        records,
        page: data.payload.paginaActual || 0,
        totalPages: data.payload.totalPaginas || 0,
        totalRecords: data.payload.totalResultados || 0
      })
    )
  } catch (error) {
    return dispatch(onGetSpecificProvidersError({ error }))
  }
}
